import React from 'react';

export function EditPageContentIcon({ ...props }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.66695 5.83322C6.66695 5.37299 7.04005 4.99989 7.50028 4.99989H12.5003C12.9605 4.99989 13.3336 5.37299 13.3336 5.83322V9.16656C13.3336 9.62679 12.9605 9.99989 12.5003 9.99989H7.50028C7.04005 9.99989 6.66695 9.62679 6.66695 9.16656V5.83322ZM8.33362 6.66656V8.33322H11.667V6.66656H8.33362Z"
        fill="inherit"
      />
      <path
        d="M7.50028 11.6666C7.04005 11.6666 6.66695 12.0397 6.66695 12.4999C6.66695 12.9601 7.04005 13.3332 7.50028 13.3332H10.8336C11.2939 13.3332 11.667 12.9601 11.667 12.4999C11.667 12.0397 11.2939 11.6666 10.8336 11.6666H7.50028Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33362 4.16656C3.33362 2.78585 4.45291 1.66656 5.83362 1.66656H14.167C15.5477 1.66656 16.667 2.78585 16.667 4.16656V15.8332C16.667 17.2139 15.5477 18.3332 14.167 18.3332H5.83362C4.45291 18.3332 3.33362 17.2139 3.33362 15.8332V4.16656ZM5.83362 3.33322C5.37338 3.33322 5.00028 3.70632 5.00028 4.16656V15.8332C5.00028 16.2935 5.37338 16.6666 5.83362 16.6666H14.167C14.6272 16.6666 15.0003 16.2935 15.0003 15.8332V4.16656C15.0003 3.70632 14.6272 3.33322 14.167 3.33322H5.83362Z"
        fill="inherit"
      />
    </svg>
  );
}
